import { useState, useCallback, useEffect, useMemo } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { ICorpUI } from 'src/types/Corp';
import { getSelfServiceCorporateData } from 'src/components/selfService/common/SelfServiceCorporateData/api/selfServiceCorporateApi';
import { SelfServiceCorporateDataContextType } from 'src/components/selfService/common/SelfServiceCorporateData/SelfServiceCorporateDataContext';

interface UseSelfServiceCorporateDataProps {
  corpId: string;
}

export const useFetchSelfServiceCorporateData = ({
  corpId,
}: UseSelfServiceCorporateDataProps): SelfServiceCorporateDataContextType => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [corpData, setCorpData] = useState<ICorpUI | null>(null);

  const fetchCorporateData = useCallback(async () => {
    if (!corpId) return;

    try {
      setIsLoading(true);
      setHasError(false);

      const data = await getSelfServiceCorporateData(corpId);

      setCorpData(data);
    } catch (error) {
      setHasError(true);
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, [corpId]);

  useEffect(() => {
    fetchCorporateData();
  }, [fetchCorporateData]);

  return useMemo(
    () => ({ corpData, isLoading, hasError, refetch: fetchCorporateData }),
    [corpData, isLoading, hasError, fetchCorporateData]
  );
};
